import React from 'react'

export const Cart = () => {
  return (
    <div><h2> Carrito - Página en construcción </h2></div>
  )
}
